<template>
    <div>
        <div class="card">
            <div class="card-header form-inline">
                Previous Discipline
                ({{ previous_actions.length }})
                -
                <span class="input-group input-group-sm ml-1">
                    <div class="input-group-prepend">
                        <span class="input-group-text bg-light">In the last:</span>
                    </div>
                    <input type="text" v-model="previous_action_days" class="form-control" />
                    <div class="input-group-append">
                        <span class="input-group-text bg-light">Days</span>
                    </div>
                </span>
            </div>
            <div class="card-body">
                <template v-if="previous_actions_loading">
                    <i class="fa fa-circle-o-notch fa-spin"></i> Loading Previous Violations
                </template>
                <template v-else>
                    <template v-if="employee_id">
                        <ul v-if="previous_actions.length > 0">
                            <li v-for="act in previous_actions">
                                <router-link :to="`/employees/disciplinary-actions/view/${act.disc_action_id}`" target="_blank">
                                    <template v-if="act.disc_violation_id">{{ act.violation_name }}</template>
                                    <template v-else>{{ act.other_violation_name }}</template>
                                     on {{ act.disc_action_date | moment("MM/DD/YYYY") }}
                                </router-link>
                            </li>
                        </ul>
                        <span v-else>
                            -- No Previous Violations, Gold Star --
                        </span>
                    </template>
                    <template v-else>
                        -- Select an Employee to Load Previous Violations --
                    </template>
                </template>
            </div>
        </div>
    </div>
</template>

<script>
    import moment from 'moment-timezone';

    export default {

        props: ['disc_action_id'],

        data: function() {
            return {
                employee_id: null,
                previous_actions_loading: false,
                previous_action_days: 180,
                previous_actions: [],
            }
        },

        watch: {
            employee_id: function(newVal, oldVal){
                //Call loader
                this.loadPreviousActions();
            },

            previous_action_days: function(newVal, oldVal){
                //Check for empty or 0
                if(newVal == '' || newVal < 1)
                {
                    //Alert the user
                    this.$toastr.warning('Previous Days must be a positive, non-empty integer');

                    //Stop here
                    return;
                }

                //Getter
                this.loadPreviousActions();
            }
        },

        methods: {
            //Setter
            setEmployeeId(id){
                this.employee_id = id;
            },

            //Load Previous
            loadPreviousActions(){
                //Set loading
                this.previous_actions_loading = true;

                //Check ID
                if(!this.employee_id)
                {
                    //Set to empty
                    this.previous_actions = [];
                    this.previous_actions_loading = false;

                    //Send it
                    return;
                }

                //Get the date based on the number of days
                var gteDate = moment().subtract(this.previous_action_days, 'days').format('MM/DD/YYYY');

                //Build the payload
                var payload = {
                    exclude_id: this.disc_action_id,
                    filters: {
                        'disciplinary_actions.employee_id': this.employee_id,
                        'disciplinary_actions.disc_action_date': 'gte:'+gteDate,
                    }
                };

                //Get the actions
                this.$http.get('/employees/disciplinary-actions/list', payload)
                    .then(res => {
                        //Set it
                        this.previous_actions = res.data.data;
                    })
                    .catch(err => {
                        //Alert
                        this.$toastr.error(err);
                    })
                    .then(() => {
                        //Send it
                        this.previous_actions_loading = false;
                    });
            },
        },

        mounted() {

        }
    }
</script>
